import React from "react";
import './_static/Buttons.css';

function PreviousPage(props) {

    function navigatePreviousPage() {
        props.changePage()
    }

    return (
        // <div className="mb-3">
                <button type="button" className="btn btn-outline-primary btn-md bigButton" style={{"opacity": "0.8"}} onClick={navigatePreviousPage}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                    </svg>Späť
                </button >
        // </div>
    )
}

export default PreviousPage
